export default "__VITE_ASSET__DbiHdY$i__"